<template>
<div class="chapter">
<div class="inner_page">
<div id="abbreviations">
<a id="page_xvii">
</a><p class="chap-title paracenter" id="abb" style="margin-top:3em!important; margin-bottom:1.5em!important;"><a id="page_xvii"></a><a href="#/text/06_toc#abb"><b>Abbreviations</b></a></p>
<table width="100%">
<colgroup>
<col width="10%"/>
<col width="90%"/>
</colgroup>
<tbody><tr>
<td valign="top">ABCA</td>
<td valign="top">American, British, Canadian, &amp; Australian (Equipment study group)</td>
</tr>
<tr>
<td valign="top">ABLE</td>
<td valign="top">Automotive Bridge Launching Equipment</td>
</tr>
<tr>
<td valign="top">AGRE</td>
<td valign="top">Army Group Royal Engineers</td>
</tr>
<tr>
<td valign="top">AEV</td>
<td valign="top">Armoured Engineer Vehicle</td>
</tr>
<tr>
<td valign="top">AFB</td>
<td valign="top">Axial Folding Bridge</td>
</tr>
<tr>
<td valign="top">AFV</td>
<td valign="top">Armoured Fighting Vehicle</td>
</tr>
<tr>
<td valign="top">ANZAC</td>
<td valign="top">Australian &amp; New Zealand Army Corps</td>
</tr>
<tr>
<td valign="top">APB</td>
<td valign="top">Air Portable Bridge</td>
</tr>
<tr>
<td valign="top">APC</td>
<td valign="top">Armoured Personnel Carrier</td>
</tr>
<tr>
<td valign="top">ARDE</td>
<td valign="top">Armament Research &amp; Development Establishment</td>
</tr>
<tr>
<td valign="top">ARK</td>
<td valign="top">Armoured Ramp Carrier</td>
</tr>
<tr>
<td valign="top">AVLB</td>
<td valign="top">Armoured Vehicle Launched Bridge</td>
</tr>
<tr>
<td valign="top">AVRE</td>
<td valign="top">Armoured Vehicle Royal Engineers</td>
</tr>
<tr>
<td valign="top">BAOR</td>
<td valign="top">British Army of the Rhine</td>
</tr>
<tr>
<td valign="top">BB</td>
<td valign="top">Bailey Bridge</td>
</tr>
<tr>
<td valign="top">BEF</td>
<td valign="top">British Expeditionary Force</td>
</tr>
<tr>
<td valign="top">BMB</td>
<td valign="top">Bailey Mobile Bridge</td>
</tr>
<tr>
<td valign="top">BPB</td>
<td valign="top">Bailey Pontoon Bridge</td>
</tr>
<tr>
<td valign="top">BRAVE</td>
<td valign="top">Bridge Articulated Vehicle Equipment</td>
</tr>
<tr>
<td valign="top">BR80/90</td>
<td valign="top">Bridging for the 1980s/90s</td>
</tr>
<tr>
<td valign="top">BS</td>
<td valign="top">British Standard</td>
</tr>
<tr>
<td valign="top">BSB</td>
<td valign="top">Bailey Suspension Bridge</td>
</tr>
<tr>
<td valign="top">CCRE</td>
<td valign="top">Commander Corps Royal Engineers</td>
</tr>
<tr>
<td valign="top">CE</td>
<td valign="top">Chief Engineer</td>
</tr>
<tr>
<td valign="top">CET</td>
<td valign="top">Combat Engineer Tractor</td>
</tr>
<tr>
<td valign="top">CF</td>
<td valign="top">Carbon Fibre</td>
</tr>
<tr>
<td valign="top">CFRP</td>
<td valign="top">Carbon Fibre Reinforced Plastic</td>
</tr>
<tr>
<td valign="top">C-H</td>
<td valign="top">Callender-Hamilton</td>
</tr>
<tr>
<td valign="top">CRE</td>
<td valign="top">Commander Royal Engineers</td>
</tr>
<tr>
<td valign="top">CS</td>
<td valign="top">Close Support</td>
</tr>
<tr>
<td valign="top">CSB</td>
<td valign="top">Close Support Bridge</td>
</tr>
<tr>
<td valign="top">CSR</td>
<td valign="top">Close Support Raft</td>
</tr>
<tr>
<td valign="top">DCE</td>
<td valign="top">Deputy Chief Engineer</td>
</tr>
<tr>
<td valign="top">DDSB</td>
<td valign="top">Deliberate Dry Support Bridge</td>
</tr>
<tr>
<td valign="top">DFW</td>
<td valign="top">Director of Fortifications and Works</td>
</tr>
<tr>
<td valign="top">DGFVE</td>
<td valign="top">Director General Fighting Vehicles &amp; Engineer Equipment</td>
</tr>
<tr>
<td valign="top">DRA</td>
<td valign="top">Defence Research Agency</td>
</tr>
<tr>
<td valign="top">DREE</td>
<td valign="top">Director Royal Engineer Equipment</td>
</tr>
<tr>
<td valign="top">DUKW</td>
<td valign="top">A General Motors Amphibious Vehicle</td>
</tr>
<tr>
<td valign="top">DWSB</td>
<td valign="top">Deliberate Wet Support Bridge</td>
</tr>
<tr>
<td valign="top">EBC</td>
<td valign="top">Experimental Bridging Company</td>
</tr>
<tr>
<td valign="top"><a id="page_xviii">EBE</a></td>
<td valign="top">Experimental Bridging Establishment</td>
</tr>
<tr>
<td valign="top">EEF</td>
<td valign="top">Egyptian Expeditionary Force</td>
</tr>
<tr>
<td valign="top">E-in-C</td>
<td valign="top">Engineer-in-Chief</td>
</tr>
<tr>
<td valign="top">ESTRB</td>
<td valign="top">Everall Sectional Truss Railway Bridge</td>
</tr>
<tr>
<td valign="top">EWBB</td>
<td valign="top">Extra Widened Bailey Bridge</td>
</tr>
<tr>
<td valign="top">FBE</td>
<td valign="top">Folding Boat Equipment</td>
</tr>
<tr>
<td valign="top">FCT</td>
<td valign="top">Final Concept Team (for BR80)</td>
</tr>
<tr>
<td valign="top">Fd</td>
<td valign="top">Coy Field Company</td>
</tr>
<tr>
<td valign="top">Fd</td>
<td valign="top">Sqn Field Squadron</td>
</tr>
<tr>
<td valign="top">FV</td>
<td valign="top">Fighting Vehicle</td>
</tr>
<tr>
<td valign="top">FVRDE</td>
<td valign="top">Fighting Vehicle Research &amp; Development Establishment</td>
</tr>
<tr>
<td valign="top">GHQ</td>
<td valign="top">General Headquarters</td>
</tr>
<tr>
<td valign="top">GREF</td>
<td valign="top">General Reserve Engineer Force</td>
</tr>
<tr>
<td valign="top">GS</td>
<td valign="top">General Staff or General Support</td>
</tr>
<tr>
<td valign="top">GSB</td>
<td valign="top">General Support Bridge</td>
</tr>
<tr>
<td valign="top">GSOR</td>
<td valign="top">General Staff Operational Requirement</td>
</tr>
<tr>
<td valign="top">GSR</td>
<td valign="top">General Staff Requirement</td>
</tr>
<tr>
<td valign="top">GST</td>
<td valign="top">General Staff Target</td>
</tr>
<tr>
<td valign="top">HAFB</td>
<td valign="top">Heavy Assault Floating Bridge</td>
</tr>
<tr>
<td valign="top">HFB</td>
<td valign="top">Heavy Floating Bridge</td>
</tr>
<tr>
<td valign="top">HGB</td>
<td valign="top">Heavy Girder Bridge</td>
</tr>
<tr>
<td valign="top">HyF</td>
<td valign="top">Heavy Ferry</td>
</tr>
<tr>
<td valign="top">ICST</td>
<td valign="top">International Concept Study Team (for BR80)</td>
</tr>
<tr>
<td valign="top">IE</td>
<td valign="top">Indian Engineers</td>
</tr>
<tr>
<td valign="top">IFOR</td>
<td valign="top">Implementation Force (in Bosnia)</td>
</tr>
<tr>
<td valign="top">ISD</td>
<td valign="top">In Service Date</td>
</tr>
<tr>
<td valign="top">IWM</td>
<td valign="top">Imperial War Museum</td>
</tr>
<tr>
<td valign="top">IWT</td>
<td valign="top">Inland Water Transport</td>
</tr>
<tr>
<td valign="top">LAFB</td>
<td valign="top">Light Assault Floating Bridge</td>
</tr>
<tr>
<td valign="top">LAR</td>
<td valign="top">Light Assault Raft</td>
</tr>
<tr>
<td valign="top">LBG</td>
<td valign="top">Large Box Girder</td>
</tr>
<tr>
<td valign="top">LFB</td>
<td valign="top">Light Floating Bridge</td>
</tr>
<tr>
<td valign="top">L</td>
<td valign="top">of C Line of Communication</td>
</tr>
<tr>
<td valign="top">LR</td>
<td valign="top">Light Raft</td>
</tr>
<tr>
<td valign="top">LSL</td>
<td valign="top">Landing Ship Logistic</td>
</tr>
<tr>
<td valign="top">LSOR</td>
<td valign="top">Land Systems, Operational Requirements</td>
</tr>
<tr>
<td valign="top">LVT</td>
<td valign="top">Landing Vehicle Tracked (the Buffalo)</td>
</tr>
<tr>
<td valign="top">LWT</td>
<td valign="top">Light Wheeled Tractor</td>
</tr>
<tr>
<td valign="top">MAB</td>
<td valign="top">Mobile Assault Bridge</td>
</tr>
<tr>
<td valign="top">MACH</td>
<td valign="top">Mechanically Assisted Construction by Hand</td>
</tr>
<tr>
<td valign="top">MERADCOM</td>
<td valign="top">Military Engineering Research &amp; Development Command</td>
</tr>
<tr>
<td valign="top">MBT</td>
<td valign="top">Main Battle Tank</td>
</tr>
<tr>
<td valign="top">MEXE</td>
<td valign="top">Military Engineering Experimental Establishment</td>
</tr>
<tr>
<td valign="top">MGB</td>
<td valign="top">Medium Girder Bridge</td>
</tr>
<tr>
<td valign="top"><a id="page_xix">MGO</a></td>
<td valign="top">Master General of the Ordnance</td>
</tr>
<tr>
<td valign="top">MLC</td>
<td valign="top">Military Load Class</td>
</tr>
<tr>
<td valign="top">MOD</td>
<td valign="top">Ministry of Defence</td>
</tr>
<tr>
<td valign="top">MVEE</td>
<td valign="top">Military Vehicle &amp; Engineering Establishment</td>
</tr>
<tr>
<td valign="top">MWT</td>
<td valign="top">Medium Wheeled Tractor</td>
</tr>
<tr>
<td valign="top">OBM</td>
<td valign="top">Outboard Motor</td>
</tr>
<tr>
<td valign="top">OC</td>
<td valign="top">Officer Commanding</td>
</tr>
<tr>
<td valign="top">OR</td>
<td valign="top">Operational Requirement</td>
</tr>
<tr>
<td valign="top">ORBAT</td>
<td valign="top">Order of Battle</td>
</tr>
<tr>
<td valign="top">PALB</td>
<td valign="top">Pre-assembled Landing Bay</td>
</tr>
<tr>
<td valign="top">PE</td>
<td valign="top">Procurement Executive</td>
</tr>
<tr>
<td valign="top">PMGEE</td>
<td valign="top">Project Manager General Engineer Equipment</td>
</tr>
<tr>
<td valign="top">PROFOR</td>
<td valign="top">Protection Force (in Bosnia)</td>
</tr>
<tr>
<td valign="top">PWD</td>
<td valign="top">Public Works Department</td>
</tr>
<tr>
<td valign="top">RAC</td>
<td valign="top">Royal Armoured Corps</td>
</tr>
<tr>
<td valign="top">RARDE</td>
<td valign="top">Royal Armament Research &amp; Development Establishment</td>
</tr>
<tr>
<td valign="top">RASC</td>
<td valign="top">Royal Army Service Corps</td>
</tr>
<tr>
<td valign="top">RCE</td>
<td valign="top">Royal Canadian Engineers</td>
</tr>
<tr>
<td valign="top">RCT</td>
<td valign="top">Royal Corps of Transport</td>
</tr>
<tr>
<td valign="top">RE</td>
<td valign="top">Royal Engineers</td>
</tr>
<tr>
<td valign="top">REME</td>
<td valign="top">Royal Electrical &amp; Mechanical Engineers</td>
</tr>
<tr>
<td valign="top">RHQ</td>
<td valign="top">Regimental Headquarters</td>
</tr>
<tr>
<td valign="top">ROF</td>
<td valign="top">Royal Ordnance Factory</td>
</tr>
<tr>
<td valign="top">RORO</td>
<td valign="top">Roll on Roll off</td>
</tr>
<tr>
<td valign="top">RSC</td>
<td valign="top">Royal Staff Corps</td>
</tr>
<tr>
<td valign="top">RSME</td>
<td valign="top">Royal School of Military Engineering</td>
</tr>
<tr>
<td valign="top">RTR</td>
<td valign="top">Royal Tank Regiment</td>
</tr>
<tr>
<td valign="top">SAEC</td>
<td valign="top">South African Engineer Corps</td>
</tr>
<tr>
<td valign="top">SBG</td>
<td valign="top">Small Box Girder</td>
</tr>
<tr>
<td valign="top">SC</td>
<td valign="top">Steering Committee (for BR80)</td>
</tr>
<tr>
<td valign="top">SFOR</td>
<td valign="top">Stabilisation Force (in Bosnia)</td>
</tr>
<tr>
<td valign="top">SME</td>
<td valign="top">School of Military Engineering</td>
</tr>
<tr>
<td valign="top">SP</td>
<td valign="top">Self-Propelled</td>
</tr>
<tr>
<td valign="top">SPGRB</td>
<td valign="top">Sectional Plate Girder Railway Bridge</td>
</tr>
<tr>
<td valign="top">SRDE</td>
<td valign="top">Signal Research &amp; Development Establishment</td>
</tr>
<tr>
<td valign="top">SWBB</td>
<td valign="top">Standard Widened Bailey Bridge</td>
</tr>
<tr>
<td valign="top">SWR</td>
<td valign="top">Steel Wire Rope</td>
</tr>
<tr>
<td valign="top">UCB</td>
<td valign="top">Unit Construction Bridge</td>
</tr>
<tr>
<td valign="top">UCRB</td>
<td valign="top">Unit Construction Railway Bridge</td>
</tr>
<tr>
<td valign="top">VAB</td>
<td valign="top">Vickers Assault Bridge</td>
</tr>
<tr>
<td valign="top">WVL</td>
<td valign="top">Wheeled Vehicle Launcher</td>
</tr>
</tbody></table>
<a id="page_xx">
</a></div><a id="page_xx">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 10_abbreviations.vue?5241628e